/**
 * Shared language constants used across the application.
 * 
 * IMPORTANT: This file is generated from /app/shared/language-config.json
 * which is generated from backend constants.py
 * 
 * To update: Run `python /app/scripts/generate_language_config.py`
 * then copy the relevant values here.
 */

// Import shared config (loaded at build time via CRA)
import languageConfig from '../shared/language-config.json';

// Standard language codes used in the application
export const LANGUAGE_CODES = languageConfig.languageCodes;

// Language code aliases for normalization (from shared config)
const LANGUAGE_ALIASES = languageConfig.languageAliases;

/**
 * Normalize various language inputs to standard language code.
 * @param {string} lang - Language input (e.g., 'ja', 'japanese', '日本語')
 * @returns {string|null} - Normalized language code or null if not recognized
 */
export const normalizeLanguage = (lang) => {
  if (!lang) return null;
  const normalized = LANGUAGE_ALIASES[lang.toLowerCase().trim()];
  return normalized || null;
};

/**
 * Check if language code represents Japanese.
 * @param {string} lang - Language code to check
 * @returns {boolean}
 */
export const isJapanese = (lang) => {
  return normalizeLanguage(lang) === LANGUAGE_CODES.JAPANESE;
};

/**
 * Check if language code represents Korean.
 * @param {string} lang - Language code to check
 * @returns {boolean}
 */
export const isKorean = (lang) => {
  return normalizeLanguage(lang) === LANGUAGE_CODES.KOREAN;
};

/**
 * Check if language code represents English.
 * @param {string} lang - Language code to check
 * @returns {boolean}
 */
export const isEnglish = (lang) => {
  return normalizeLanguage(lang) === LANGUAGE_CODES.ENGLISH;
};

// Messaging platform configuration by language (from shared config)
export const MESSAGING_PLATFORMS = languageConfig.messagingPlatforms;

/**
 * Get messaging platform config for a given language.
 * @param {string} lang - Language code
 * @returns {object|null} - Platform config or null if no platform for this language
 */
export const getMessagingPlatform = (lang) => {
  const normalized = normalizeLanguage(lang);
  if (!normalized) return null;
  return MESSAGING_PLATFORMS[normalized] || null;
};

/**
 * Get all supported language codes as an array.
 * @returns {string[]} - Array of language code values
 */
export const getSupportedLanguages = () => {
  return Object.values(LANGUAGE_CODES);
};

/**
 * Check if a language is supported.
 * @param {string} lang - Language to check
 * @returns {boolean}
 */
export const isSupportedLanguage = (lang) => {
  return normalizeLanguage(lang) !== null;
};
